import { useMutation } from "react-query";
import {
  RelatorioReceitasPdfResponse,
  RelatorioReceitasQueryParams,
} from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioReceitasPdf(query: RelatorioReceitasQueryParams) {
  return useMutation<RelatorioReceitasPdfResponse, AxiosError>(
    [`/v1/relatorios/financeiro/receitas/pdf`, query],
    async () => {
      const { data } = await http.get<RelatorioReceitasPdfResponse>(
        "/v1/relatorios/financeiro/receitas/pdf",
        {
          params: query,
        }
      );

      return data;
    }
  );
}

export default useRelatorioReceitasPdf;
